import { EventName } from '@lit/react';
import { BlocksAccordion } from 'blocks-nextjs/blocks-web-components/components/accordion/accordion';
import { BlockAccordionCloseEvent, BlockAccordionOpenEvent } from 'blocks-nextjs/blocks-web-components/events';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';

export const CatAccordion = createComponent({
  react: React,
  tagName: 'cat-accordion',
  elementClass: BlocksAccordion,
  events: {
    onBlAccordionOpen: 'bl-accordion-open' as EventName<BlockAccordionOpenEvent>,
    onBlAccordionClose: 'bl-accordion-close' as EventName<BlockAccordionCloseEvent>
  }
});
